function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgLoadingLoader = function SvgLoadingLoader(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlSpace: "preserve",
    width: 60,
    height: 60,
    viewBox: "0 0 512 512"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M267.636 0c-12.853 0-23.273 10.42-23.273 23.273v93.091c0 12.853 10.42 23.273 23.273 23.273s23.273-10.42 23.273-23.273V23.273C290.909 10.42 280.489 0 267.636 0",
    style: {
      fill: "#2d50a7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M267.638 372.364c-12.853 0-23.273 10.42-23.273 23.273v93.091c0 12.853 10.42 23.273 23.273 23.273s23.273-10.42 23.273-23.273v-93.091c0-12.853-10.42-23.273-23.273-23.273",
    style: {
      fill: "#73a1fb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M185.355 140.808 119.529 74.98c-9.086-9.089-23.822-9.089-32.912 0s-9.089 23.824 0 32.912l65.826 65.828a23.2 23.2 0 0 0 16.455 6.817 23.2 23.2 0 0 0 16.455-6.817c9.091-9.089 9.091-23.823.002-32.912",
    style: {
      fill: "#355ec9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M477.091 232.727h-46.545c-12.853 0-23.273 10.42-23.273 23.273s10.42 23.273 23.273 23.273h46.545c12.853 0 23.273-10.42 23.273-23.273s-10.42-23.273-23.273-23.273M382.83 338.283c-9.087-9.089-23.823-9.087-32.912 0-9.089 9.089-9.087 23.823 0 32.912l65.828 65.825a23.2 23.2 0 0 0 16.457 6.816 23.2 23.2 0 0 0 16.455-6.816c9.089-9.089 9.089-23.824 0-32.912z",
    style: {
      fill: "#c4d9fd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M151.273 256c0-12.853-10.42-23.273-23.273-23.273H34.909c-12.853 0-23.273 10.42-23.273 23.273s10.42 23.273 23.273 23.273H128c12.853 0 23.273-10.42 23.273-23.273",
    style: {
      fill: "#3d6deb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M185.355 338.283c-9.087-9.089-23.824-9.089-32.912 0l-65.825 65.825c-9.089 9.087-9.089 23.824 0 32.912a23.2 23.2 0 0 0 16.457 6.816 23.2 23.2 0 0 0 16.455-6.816l65.825-65.825c9.089-9.087 9.089-23.823 0-32.912",
    style: {
      fill: "#5286fa"
    }
  }));
};
export default SvgLoadingLoader;